import React from 'react';
import { ArrowRight, BookOpen, Globe } from 'lucide-react';
import { heroData } from '../data/mock';

export const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with vibrant gradient */}
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${heroData.heroImage})`,
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/95 via-blue-500/90 to-cyan-500/85" />
        
        {/* Bright animated elements */}
        <div className="absolute top-20 left-10 w-72 h-72 bg-amber-400/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-cyan-400/20 rounded-full blur-3xl animate-pulse delay-700" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="space-y-8 animate-fadeIn">
          {/* Bright Badge */}
          <div className="inline-flex items-center space-x-2 bg-amber-400/20 backdrop-blur-md border-2 border-amber-300/50 rounded-full px-6 py-3 text-white shadow-lg">
            <Globe className="w-5 h-5 text-amber-300" />
            <span className="text-sm font-bold">Globally Recognized • Top 5 Education System</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-tight drop-shadow-lg">
            {heroData.title}
          </h1>

          {/* Subtitle with bright accent */}
          <div className="space-y-2">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-amber-300 drop-shadow-md">
              {heroData.subtitle}
            </h2>
            <p className="text-xl sm:text-2xl text-cyan-100 max-w-3xl mx-auto font-semibold">
              {heroData.description}
            </p>
          </div>

          {/* Description */}
          <p className="text-lg sm:text-xl text-white/95 max-w-2xl mx-auto leading-relaxed">
            Unlock your potential with OSSD - the premium pathway to top universities in Canada, USA, UK, Australia, and beyond
          </p>

          {/* Bright CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-6">
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-amber-400 to-orange-500 hover:from-amber-500 hover:to-orange-600 text-white px-10 py-6 text-lg font-bold rounded-xl shadow-2xl hover:shadow-amber-500/50 transition-all duration-300 hover:scale-105 group"
            >
              {heroData.cta1}
              <ArrowRight className="w-5 h-5 ml-2 inline group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="border-3 border-white bg-white/10 backdrop-blur-sm text-white hover:bg-white hover:text-blue-900 px-10 py-6 text-lg font-bold rounded-xl transition-all duration-300 hover:scale-105 group"
            >
              <BookOpen className="w-5 h-5 mr-2 inline" />
              {heroData.cta2}
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/70 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-amber-300 rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  );
};
